export default "__VITE_ASSET__CYTENK$s__"